import { format, parse, isValid } from 'date-fns';

// YYYY-MM-DD
export const formatDateToYMD = (date) => {
  if (!date) return '';

  const formatsToTry = [
    'MM/dd/yyyy',
    'dd/MM/yyyy',
    'yyyy-MM-dd',
    'MM-dd-yyyy',
    'dd-MM-yyyy',
    'yyyy/MM/dd',
  ];

  for (const fmt of formatsToTry) {
    const parsed = parse(date, fmt, new Date());
    if (isValid(parsed)) {
      return format(parsed, 'yyyy-MM-dd');
    }
  }

  return '';
};


export const formatLocalDate = (date) => {
  date.toLocaleDateString('sv-SE');
}